import React from 'react';
import { Card, Typography, Avatar, Button, Space } from 'antd';
import { IdcardOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';
import './index.scss'
import ProfileCard from './ProfileCard';

const { Title, Text } = Typography;

interface ContactInfoProps {
    name: string;
    role: string;
    email: string;
    phone: string;
    avatarUrl: string;
    employeeID?: string;
}

const ContactInfo: React.FC<ContactInfoProps> = ({ name, role, email, phone, avatarUrl, employeeID }) => (
    <Space direction='vertical' style={{ width: '100%' }}>
        <Space direction='horizontal' className='contact_info'>
            <ProfileCard avatarUrl={avatarUrl} name={name} role={role} />
        </Space>
        <div>
            <Space direction='horizontal'>
                <MailOutlined style={{ marginRight: 8 }} />
                <Text style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    width: '193px',
                    display: 'block'
                }}>{email}</Text>
            </Space>
            <div>
                <Space direction='horizontal'>
                    <PhoneOutlined style={{ marginRight: 8 }} />
                    <Text ellipsis>{phone}</Text>
                </Space>
            </div>
            {employeeID && <div>
                <Space direction='horizontal'>
                    <IdcardOutlined style={{ marginRight: 8 }} />
                    <Text>{employeeID}</Text>
                </Space>
            </div>}
        </div>
    </Space>
);

export default ContactInfo;
